import { render, staticRenderFns } from "./system_serve.vue?vue&type=template&id=fef16b26&scoped=true&"
import script from "./system_serve.vue?vue&type=script&lang=js&"
export * from "./system_serve.vue?vue&type=script&lang=js&"
import style0 from "./system_serve.vue?vue&type=style&index=0&id=fef16b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef16b26",
  null
  
)

export default component.exports